import { render, staticRenderFns } from "./faqDetailPage.vue?vue&type=template&id=49048994&"
import script from "./faqDetailPage.vue.ts?vue&type=script&lang=ts&"
export * from "./faqDetailPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports